import React from 'react';
import BlueDotsBackground from '../BlueDotsBackground';
import people from '../content/people';
import partners from '../content/partners';

export default function About() {
  return (
    <>
      <BlueDotsBackground />
      <div className="min-h-screen text-white px-6 py-12 space-y-20">
        {/* Mission Section */}
        <section id="mission" className="text-center">
          <h2 className="text-3xl font-bold mb-8">Our Mission</h2>
          <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 shadow-md max-w-4xl mx-auto">
            <p className="mb-4">
              Our mission is to help pharmaceutical manufacturers with{' '}
              <strong>market access and financial solutions</strong> that are{' '}
              <strong>adaptable and compliant</strong>, streamlining operations
              and enhancing decision-making.
            </p>
            <p className="mb-4">
              We are committed to <strong>customer excellence</strong>,{' '}
              <strong>product innovation</strong>,{' '}
              <strong>company stewardship</strong>, and{' '}
              <strong>integrity</strong>.
            </p>
            <p>
              We envision a world where manual processes have been replaced by a
              fully integrated solution - empowering our customers to focus on
              developing new therapies and making them easily accessible to
              patients.
            </p>
          </div>
        </section>

        {/* Principles Section */}
        <section id="principles" className="text-white px-6 py-16">
          <h2 className="text-3xl font-bold text-center mb-12">
            Our Principles
          </h2>

          {/* Top Row: 3 Principles */}
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md text-center">
              <i className="fas fa-user-check text-blue-400 text-3xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">Customer Focus</h3>
              <p>
                Our customers are at the heart of everything we do. We tailor
                solutions to meet their evolving needs.
              </p>
            </div>

            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md text-center">
              <i className="fas fa-lightbulb text-blue-400 text-3xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">Product Innovation</h3>
              <p>
                We iterate constantly - delivering new value with every release,
                guided by customer feedback.
              </p>
            </div>

            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md text-center">
              <i className="fas fa-building text-blue-400 text-3xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">
                Company Stewardship
              </h3>
              <p>
                We are building a company that can serve our customers,
                employees, and partners long into the future.
              </p>
            </div>
          </div>

          {/* Bottom: Integrity */}
          <div className="mt-12 text-center max-w-2xl mx-auto">
            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md">
              <i className="fas fa-scale-balanced text-blue-400 text-3xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">Integrity</h3>
              <p>
                We act with transparency, humility, and accountability -
                building trust in every interaction.
              </p>
            </div>
            <p className="mt-12 text-sm text-gray-300">
              We evaluate our actions and decisions through the lens of these
              principles - with the goal of building lasting trust with our
              customers, employees, and partners.
            </p>
          </div>
        </section>

        {/* People Section */}
        <section>
          <h2 className="text-3xl font-bold text-center mb-8">Our People</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto text-center">
            {people.map((person, index) => (
              <div key={index} className="flex flex-col items-center space-y-2">
                <img
                  src={person.image}
                  alt={person.name}
                  className="w-24 h-24 rounded-full object-cover border-2 border-white/30 shadow-md"
                />
                <div className="text-lg font-semibold">{person.name}</div>
                <div className="text-sm text-gray-300">{person.title}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Partners Section */}
        <section>
          <h2 className="text-3xl font-bold text-center mb-8">Our Partners</h2>
          <div className="relative overflow-hidden w-full">
            <div className="flex animate-scroll whitespace-nowrap w-max">
              {[...partners, ...partners].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Partner ${i + 1}`}
                  className="h-16 w-auto object-contain mx-20"
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
